import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import ClearAllIcon from '@jupiterone/react-brand-icons/jupiterone/clear-list';
import { createStyles, makeStyles } from '@material-ui/core';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    icon: {
      height: 29,
      width: 30,
    },
    iconButton: {
      alignSelf: 'flex-start',
      padding: '15px 7.5px',
      borderRadius: 0,
      color: theme.palette.coolGrey[300],
      '&:hover svg': {
        color: theme.palette.primary.dark,
      },
    },
  })
);

const ClearSearchesButton = (props: IconButtonProps) => {
  const classes = useStyles();

  return (
    <Tooltip title="Clear all" enterDelay={500} placement="top">
      <IconButton
        className={classes.iconButton}
        aria-label="Clear all"
        {...props}
      >
        <ClearAllIcon className={classes.icon} />
      </IconButton>
    </Tooltip>
  );
};

export default ClearSearchesButton;
